import React from 'react';
import './Header.scss';
import { Avatar , Button, Popover } from "@axtria/design-system-react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import ProfileSwitch from './ProfileSwitch';
import Notification from '../../components/Notification';

interface RootState {
  loginResource: any;
}
export const Header : React.FC = () => {
const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
const loginData = useSelector((state: RootState) => state.loginResource);
const isProfilePopoverOpen = Boolean(anchorEl);
const handleClose = () => {
  setAnchorEl(null);
}
const handleToggle = (e: React.MouseEvent<HTMLElement>) => {
  e.stopPropagation();
  setAnchorEl((current) => (current ? null : e.currentTarget));
}

  return (
    <div className="container">
      <div className="right-aligned-group">
        <div className='info'>
          <FontAwesomeIcon icon={faInfoCircle as IconProp} opacity={0.6} pointerEvents={'none'} />
        </div>
        <Notification />

        <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px'}}>
            <Button className='switcherButton' onClick={handleToggle}  variant='secondary'>
              <Avatar id = "user-name">{loginData.first_name
                        ? _.upperFirst(loginData.first_name.charAt(0))
                        : loginData.username && _.upperFirst(loginData.username.charAt(0))}
                      {loginData.last_name ? _.upperFirst(loginData.last_name.charAt(0)) : ''}</Avatar>
            </Button>
        </div>
      </div>
      <Popover
        open={isProfilePopoverOpen}
        anchorEl={anchorEl}
        className="profile-right-popover"
        popoverWidth="376px"
        onClose={handleClose}
      >
        <ProfileSwitch onClose={handleClose} />
      </Popover>
    </div>
  )
}
